import Main from './modules/Main.js'
import Utils from './modules/Utils.js'
import 'container-query-polyfill'
import 'lite-youtube-embed'

const modules = {
  AccordionFactory: async () =>
    import(
      /* webpackChunkName: 'AccordionFactory' */ `./factories/AccordionFactory.js`
    ),
  AlertBanner: async () =>
    import(/* webpackChunkName: 'AlertBanner' */ `./modules/AlertBanner.js`),
  Aside: async () =>
    import(/* webpackChunkName: 'Aside' */ `./modules/Aside.js`),
  BackToTop: async () =>
    import(/* webpackChunkName: 'BackToTop' */ `./modules/BackToTop.js`),
  Breadcrumbs: async () =>
    import(/* webpackChunkName: 'Breadcrumbs' */ `./modules/Breadcrumbs.js`),
  DatePicker: async () =>
    import(/* webpackChunkName: 'DatePicker' */ `./modules/DatePicker.js`),
  ErrorPageContent: async () =>
    import(
      /* webpackChunkName: 'ErrorPageContent' */ `./modules/ErrorPageContent.js`
    ),
  ExampleFactory: async () =>
    import(
      /* webpackChunkName: 'ExampleFactory' */ `./factories/ExampleFactory.js`
    ),
  FormFactory: async () =>
    import(/* webpackChunkName: 'FormFactory' */ `./factories/FormFactory.js`),
  HeroVideoFactory: async () =>
    import(
      /* webpackChunkName: 'HeroVideoFactory' */ `./factories/HeroVideoFactory.js`
    ),
  Footer: async () =>
    import(/* webpackChunkName: 'Footer' */ `./modules/Footer.js`),
  Header: async () =>
    import(/* webpackChunkName: 'Header' */ `./modules/Header.js`),
  LocationDetailGalleryFactory: async () =>
    import(
      /* webpackChunkName: 'LocationDetailGalleryFactory' */ `./factories/LocationDetailGalleryFactory.js`
    ),
  LocationSummary: async () =>
    import(
      /* webpackChunkName: 'LocationSummary' */ `./modules/LocationSummary.js`
    ),
  ModalFactory: async () =>
    import(
      /* webpackChunkName: 'ModalFactory' */ `./factories/ModalFactory.js`
    ),
  NavigationLinks: async () =>
    import(
      /* webpackChunkName: 'NavigationLinks' */ `./modules/NavigationLinks.js`
    ),
  PrintButtonFactory: async () =>
    import(
      /* webpackChunkName: 'PrintButtonFactory' */ `./factories/PrintButtonFactory.js`
    ),
  RatingsAndReviews: async () =>
    import(
      /* webpackChunkName: 'RatingsAndReviews' */ `./modules/RatingsAndReviews.js`
    ),
  ResizableIframe: async () =>
    import(
      /* webpackChunkName: 'ResizableIframe' */ `./modules/ResizableIframe.js`
    ),
  ShowMoreFactory: async () =>
    import(
      /* webpackChunkName: 'ShowMoreFactory' */ `./factories/ShowMoreFactory.js`
    ),
  SliderFactory: async () =>
    import(
      /* webpackChunkName: 'SliderFactory' */ `./factories/SliderFactory.js`
    ),
  SubNav: async () =>
    import(/* webpackChunkName: 'SubNav' */ `./modules/SubNav.js`),
  TableFactory: async () =>
    import(
      /* webpackChunkName: 'TableFactory' */ `./factories/TableFactory.js`
    ),
  TabsFactory: async () =>
    import(/* webpackChunkName: 'TabsFactory' */ `./factories/TabsFactory.js`),
  TextWithViewMoreFactory: async () =>
    import(
      /* webpackChunkName: 'TextWithViewMoreFactory' */ `./factories/TextWithViewMoreFactory.js`
    ),
  TrackEventFactory: async () =>
    import(
      /* webpackChunkName: 'TrackEventFactory' */ `./factories/TrackEventFactory.js`
    ),
}

const mainInstance = new Main(modules, Utils)
mainInstance.init()
